import type { documents as en } from '@/i18n/locales/en/documents';
import type { Translation } from '@/i18n/types';

export const documents: Translation<typeof en> = {
  page: {
    title: 'Έγγραφα',
    lead: 'Μεταφορτώστε και διαχειριστείτε έγγραφα για την {{company}}.',
    noScope: 'Επιλέξτε μια εταιρεία για να δείτε τα έγγραφά της.',
    forbidden: 'Δεν επιτρέπεται να δείτε τα έγγραφα αυτής της εταιρείας.',
  },
  upload: {
    title: 'Μεταφόρτωση εγγράφου',
    titleField: 'Τίτλος',
    category: 'Κατηγορία',
    audience: 'Ομάδα-στόχος',
    fileUrl: 'URL αρχείου',
    file: 'Αρχείο',
    upload_status: {
      uploading: 'Μεταφόρτωση…',
      tooLarge: 'Το αρχείο είναι πολύ μεγάλο (μέγ. 10MB).',
      invalidType: 'Μη επιτρεπτός τύπος αρχείου.',
    },
    fileUrlHint: 'Μεταφορτώνεται αμέσως· ή συμπληρώστε παρακάτω ένα υπάρχον URL.',
    requiresReadConfirmation: 'Απαιτείται επιβεβαίωση ανάγνωσης',
    requiresReadConfirmationHint: 'Τα μέλη πρέπει να επιβεβαιώσουν ότι διάβασαν αυτό το έγγραφο.',
    submit: 'Μεταφόρτωση',
  },
  categories: {
    algemeen: 'Γενικά',
    beleid: 'Πολιτική',
    veiligheid: 'Ασφάλεια',
    hr: 'HR',
    vitaliteit: 'Ζωτικότητα',
  },
  audiences: {
    iedereen: 'Όλοι',
    management: 'Διοίκηση',
    per_afdeling: 'Ανά τμήμα',
    per_locatie: 'Ανά τοποθεσία',
  },
  status: {
    gepubliceerd: 'Δημοσιευμένο',
    archief: 'Αρχειοθετημένο',
  },
  library: {
    title: 'Βιβλιοθήκη εγγράφων',
    empty: 'Κανένα έγγραφο ακόμη.',
    totalViews: 'Σύνολο προβολών: {{count}}',
    columns: {
      title: 'Τίτλος',
      category: 'Κατηγορία',
      views: 'Προβολές',
      status: 'Κατάσταση',
    },
  },
  actions: {
    new: 'Μεταφόρτωση εγγράφου',
    cancel: 'Ακύρωση',
    publish: 'Δημοσίευση',
    archive: 'Αρχειοθέτηση',
  },
};
